import {Component} from "react";
import "./HeaderStyles.css"

class Header extends Component {
    constructor() {
        super();
        this.state = {
            images: ['/icons/header/vk.svg', '/icons/header/vk.png', '/icons/header/tg.svg', '/icons/header/tg.png', '/icons/header/ok.svg', '/icons/header/ok.png', '/icons/header/sfr_logo.svg', '/icons/header/sfr_logo.png'],
            isRetina: window.devicePixelRatio >= 2
        }
    }

    render() {
        let icon1 = this.state.isRetina ? this.state.images[1] : this.state.images[0];
        let icon2 = this.state.isRetina ? this.state.images[3] : this.state.images[2];
        let icon3 = this.state.isRetina ? this.state.images[5] : this.state.images[4];
        let logo = this.state.isRetina ? this.state.images[7] : this.state.images[6];
        return(
            <div className={"header"}>
                <div className={"logotitle"}>
                    <div className={"logobox"}>
                        <img src={process.env.PUBLIC_URL + logo} alt="logo"/>
                    </div>
                    <div className={"titlebox"}>
                        <h2 className={"header-title"}>Социальный фонд России</h2>
                    </div>
                </div>
                <div className={"icons-box"}>
                    <div className={"icon"}>
                        <a href={'https://vk.com/sfr'}><img src={process.env.PUBLIC_URL + icon1} alt="VK"/></a>
                    </div>
                    <div className={"icon"}>
                        <a href={'https://t.me/sfr_gov'}><img src={process.env.PUBLIC_URL + icon2} alt="Telegram"/></a>
                    </div>
                    <div className={"icon"}>
                        <a href={'https://ok.ru/sfr'}><img src={process.env.PUBLIC_URL + icon3} alt="OK"/></a>
                    </div>
                </div>
            </div>
        );
    }
}
export default Header;